import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { isLoggedIn, getUser, logout, getDashboardUrl } from "../utils/auth";

function Navbar() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (isLoggedIn()) {
      setUser(getUser());
    }
  }, []);

  const handleLogout = () => {
    logout();
    setUser(null);
    window.location.reload();
  };

  const handleDashboardClick = () => {
    window.location.href = getDashboardUrl();
  };

  return (
    <nav className="navbar">
      <div className="container navbar-inner">
        <Link to="/" className="navbar-brand">
          <img src="/media/images/logo.svg" alt="Zerodha logo" />
        </Link>
        <ul className="navbar-menu">
          <li>
            <Link to="/about">About</Link>
          </li>
          <li>
            <Link to="/product">Product</Link>
          </li>
          <li>
            <Link to="/pricing">Pricing</Link>
          </li>
          <li>
            <Link to="/support">Support</Link>
          </li>
        </ul>
        {user ? (
          <div className="navbar-user">
            <span className="navbar-user-name">Welcome, {user.name}</span>
            <button onClick={handleDashboardClick} className="btn btn-secondary">
              Go to Dashboard
            </button>
            <button onClick={handleLogout} className="btn btn-logout">
              Logout
            </button>
          </div>
        ) : (
          <Link to="/signup" className="btn btn-secondary">
            Open account
          </Link>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
